import { object } from 'zod';
import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { CustomDataInputSchema } from '@occc/validation';

export const validateCustomDataForm = makeValidate(
  object({
    customData: CustomDataInputSchema,
  }),
);
